import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import IdentityManager from '../components/IdentityManager';
import MergeAccountsModal from '../components/MergeAccountsModal';

function IdentitiesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showMergeModal, setShowMergeModal] = useState(false);
  const [mergeId, setMergeId] = useState(null);
  const [showLinkedNotice, setShowLinkedNotice] = useState(false);

  useEffect(() => {
    // Check for merge request in URL
    const mergeParam = searchParams.get('merge');
    if (mergeParam) {
      setMergeId(mergeParam);
      setShowMergeModal(true);
      // Clean up URL
      searchParams.delete('merge');
      setSearchParams(searchParams, { replace: true });
    }

    // Check for linked=true in URL
    const linkedParam = searchParams.get('linked');
    if (linkedParam === 'true') {
      setShowLinkedNotice(true);
      // Clean up URL
      searchParams.delete('linked');
      setSearchParams(searchParams, { replace: true });
      // Auto-hide after 5 seconds
      setTimeout(() => setShowLinkedNotice(false), 5000);
    }
  }, [searchParams, setSearchParams]);

  const handleCloseMergeModal = () => {
    setShowMergeModal(false);
    setMergeId(null);
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Identities</h1>

      {/* Success notice for linked accounts */}
      {showLinkedNotice && (
        <div className="p-4 bg-green-50 border border-green-200 rounded-lg flex items-center justify-between">
          <div className="flex items-center gap-3">
            <svg className="w-5 h-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-green-700">Account linked successfully!</span>
          </div>
          <button
            onClick={() => setShowLinkedNotice(false)}
            className="text-green-500 hover:text-green-700"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}

      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-lg font-semibold mb-4">Linked Accounts</h2>
        <IdentityManager />
      </div>

      {/* Merge accounts modal */}
      {showMergeModal && mergeId && (
        <MergeAccountsModal
          mergeId={mergeId}
          onClose={handleCloseMergeModal}
        />
      )}
    </div>
  );
}

export default IdentitiesPage;
